import React from 'react';
import { ContactFormConfig } from '../../../../types/ContactForm';
import './NavigationButtons.scss';

interface NavigationButtonsProps {
  config: ContactFormConfig;
  currentStep: number;
  totalSteps: number;
  isSubmitting: boolean;
  onNextStep: () => void;
  onPrevStep: () => void;
  onSubmit: (e: React.FormEvent) => void;
}

export const NavigationButtons: React.FC<NavigationButtonsProps> = ({
  config,
  currentStep,
  totalSteps,
  isSubmitting,
  onNextStep,
  onPrevStep,
  onSubmit
}) => {
  const getButtonClass = (buttonStyle: string, customClass?: string) => {
    let baseClass = '';
    switch (buttonStyle) {
      case 'secondary':
        baseClass = 'btn-secondary';
        break;
      case 'outline':
        baseClass = 'btn-outline-primary';
        break;
      default:
        baseClass = 'btn-primary';
        break;
    }
    return `btn ${baseClass} ${customClass || ''}`.trim();
  };

  if (config.isMultiStep) {
    return (
      <div className="navigationContainer">
        <div className="multiStepNavigation">
          {currentStep > 1 && (
            <button
              type="button"
              className={getButtonClass('outline', config.navButtonCssClass)}
              onClick={onPrevStep}
            >
              {config.prevButtonText || 'Zurück'}
            </button>
          )}
          
          <div className="spacer" />
          
          {currentStep < totalSteps ? (
            <button
              type="button"
              className={getButtonClass('primary', config.navButtonCssClass)}
              onClick={onNextStep}
            >
              {config.nextButtonText || 'Weiter'}
            </button>
          ) : (
            <button
              type="submit"
              disabled={isSubmitting}
              className={getButtonClass(config.buttonStyle, config.buttonCssClass)}
              onClick={onSubmit}
            >
              {isSubmitting ? 'Wird gesendet...' : (config.finalButtonText || config.buttonText)}
            </button>
          )}
        </div>
      </div>
    );
  }

  return (
          <div className="navigationContainer">
        <div className="buttonContainer" data-align={config.buttonAlign}>
        <button
          type="submit"
          disabled={isSubmitting}
          className={getButtonClass(config.buttonStyle, config.buttonCssClass)}
          onClick={onSubmit}
        >
          {isSubmitting ? 'Wird gesendet...' : config.buttonText}
        </button>
      </div>
    </div>
  );
}; 